import * as React from 'react';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

type Props = {
    user:
        | {
              id: string;
              name: string;
          }
        | null
        | undefined;
    createdTime?: number;
    modifiedTime?: number | null | undefined;
    // "Created on September 1st" vs. "Created 24 days ago"
    format: 'absolute' | 'relative';
};

/*
 * Takes a user and some timestamps and formats them consistently.
 *
 * 'Last updated 24 minutes ago by Chris Cain'
 * 'Created on July 22nd by Chris Cain'
 */
export function UserActionTimestamp(props: Props) {
    // If we have a modifiedTime, use it. Otherwise use createdTime.
    const timestamp = props.modifiedTime || props.createdTime;

    return (
        <div className='flex align-center'>
            <span>{props.modifiedTime ? 'Last updated' : 'Created'}&nbsp;</span>
            {renderTimestamp(timestamp, props.format)}
            {props.user ? <span>&nbsp;by {props.user.name}</span> : undefined}
        </div>
    );
}

function renderTimestamp(timestamp: number | null | undefined, format: 'absolute' | 'relative') {
    if (!timestamp) return null;

    return format === 'absolute' ? (
        <React.Fragment>
            <span>on&nbsp;</span>
            <FormattedTimestamp
                format={FormattedTimestamp.formats.longMonthDay}
                datetime={timestamp}
            />
        </React.Fragment>
    ) : (
        <RelativeTimestamp datetime={timestamp} />
    );
}
